import React from 'react'

const HTMLContent = ({ content }) => (
  <div dangerouslySetInnerHTML={{ __html: content }} />
)

export default HTMLContent



// WEBPACK FOOTER //
// ./components/container/Footer/HTMLContent/index.js